import { createSharedHoverContext } from './SharedHoverContext';

export const {
  SharedHoverContext,
  useSharedHoverContext,
  SharedHoverProvider,
} = createSharedHoverContext();
